export const emailValidation = (value: any) => {
    const local_language = localStorage.getItem('lang')
    if (value.length === 0) {
        return local_language == "alb" ? "Ju lutemi shkruani adresën e emailit." : 'Please enter email address.';
    } else if (!/\S+@\S+\.\S+/.test(value)) {
        return local_language == "alb" ? "Ju lutemi shkruani një adresë të vlefshme emaili." :'Please enter a valid email address.';
    }
}